/** Count-prefixed plural: `pluralize(2, 'role')` → `2 roles`. Pass `plural` for irregular words. */
export const pluralize = (
  count: number,
  singular: string,
  plural = `${singular}s`
): string => `${count} ${count === 1 ? singular : plural}`;
